import { render, staticRenderFns } from "./pageClassList.vue?vue&type=template&id=f4ec9760&scoped=true"
import script from "./pageClassList.vue?vue&type=script&lang=js"
export * from "./pageClassList.vue?vue&type=script&lang=js"
import style0 from "./pageClassList.vue?vue&type=style&index=0&id=f4ec9760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ec9760",
  null
  
)

export default component.exports